<script lang="ts">
	interface Props {
		large?: boolean
		inline?: boolean
		children?: import('svelte').Snippet
	}

	let { large = false, inline = false, children }: Props = $props()
</script>

<div class="{inline ? 'inline-flex' : 'flex'} items-center {large ? 'gap-x-2' : 'gap-x-1'}">
	{@render children?.()}
</div>
